export default class PayAgain {
	constructor() {
		this.button = document.querySelector( '[data-pay-again]' );

		if ( null === this.button ) {
			return;
		}

		this.init();
	}

	init() {
		this.button.addEventListener( 'click', ( e ) => {
			let data = new FormData();
			data.append( 'action', 'pay_again' );
			data.append( 'security', themeVars.registration.pay_again_nonce );
			data.append( 'registration_id', this.button.getAttribute( 'data-pay-again' ) );

			let request = new XMLHttpRequest();
			request.open( 'POST', themeVars.ajax_url, true );
			request.send( data );

			request.onreadystatechange = () => {
				if ( request.readyState === 4 && request.status === 200 ) {
					let response = JSON.parse( request.responseText );

					if ( response.success === true ) {
						setTimeout( () => {
							window.location.replace( response.data.redirect );
						}, 500 );
					}
				}
			}
		} );
	}
}
